import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const portfolioWalletMenuRegistry = {
    personalize_portfolioWallet: {
        label: "Portfolio Wallet",
        link: PAGE_URL.PORTFOLIO_WALLET_PAGE,
        key: PAGE_URL.PORTFOLIO_WALLET_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default portfolioWalletMenuRegistry;
